import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSelector } from "react-redux";
import { DeedListItem } from "./DeedListItem";

const DeedListTable = () => {
  const buyRequests = useSelector((state) => state.buyRequests.list);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Id de la casa</TableCell>
            <TableCell>Precio</TableCell>
            <TableCell>Información del cliente</TableCell>
            <TableCell>Información del inmueble</TableCell>
            <TableCell>Fuente</TableCell>
            <TableCell>Monto</TableCell>
            <TableCell>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {buyRequests.map((buyRequest) => (
            <DeedListItem key={buyRequest._id} {...buyRequest} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DeedListTable;
